import { baseEnvironment } from './baseEnvironment';

export const environment = {
    ...baseEnvironment,
    apiUrl: 'https://api.traceeye-ce-stg.sato.co.jp/api',
    formatArchiveUrl: 'https://traceeye-ce-stg.sato.co.jp/',
};
